import { businessDateOfTimestamp } from './business-day.js';
import { calendarDateOfUtcInstant, formatCalendarDate, isCalendarDate, toPrismaDate, } from './calendar-date.js';
import { formatBusinessDateTime } from './format.js';
import { parseInstantOrNull } from './place-time.js';
/** "Oct 1, 2026, 10:00 PM PT" for an ISO instant; null when empty or not an instant with an offset. */
export function formatBusinessDateTimeFromIso(iso) {
    const instant = parseInstantOrNull(iso);
    return instant ? formatBusinessDateTime(instant) : null;
}
/** "Oct 1, 2026": the Pacific business day of an ISO instant; null when empty or not an instant. */
export function formatBusinessDateFromIso(iso, style) {
    const instant = parseInstantOrNull(iso);
    return instant ? formatCalendarDate(businessDateOfTimestamp(instant), style) : null;
}
/**
 * The day a GraphQL value names for a kind-1 day: a `YYYY-MM-DD` as written, or the UTC day of a
 * UTC-midnight stand-in still sent as a `DateTime` (transitional and lenient, like
 * `calendarDateOfUtcInstant`); null when empty or neither. Taking the bare day as is keeps a cell
 * showing when F1 / F2b retype its column to `LocalDate`.
 */
export function calendarDateOfUtcIso(iso) {
    if (isCalendarDate(iso))
        return iso;
    const instant = parseInstantOrNull(iso);
    return instant ? calendarDateOfUtcInstant(instant) : null;
}
/** "Oct 13, 2026": {@link calendarDateOfUtcIso}'s day; null when there is none. */
export function formatCalendarDateOfUtcIso(iso, style) {
    const day = calendarDateOfUtcIso(iso);
    return day ? formatCalendarDate(day, style) : null;
}
const HALF_DAY_MS = 12 * 60 * 60 * 1000;
const LAST_CALENDAR_DATE = '9999-12-31';
/**
 * The picked day of a price-rule window bound stored as an instant: the UTC day of the instant
 * plus 12 hours (the nearest UTC midnight). The web's Pacific midnight (07:00Z / 08:00Z), UTC
 * midnight, and an old picker's local midnight from UTC-11 to UTC+12 all read the day picked; a
 * UTC-12 midnight reads the next day, and UTC+13 / +14 (New Zealand daylight time, Tonga,
 * Kiritimati) a day early. F2b's retype rounds the same way. A "forever" bound late on Dec 31,
 * 9999 reads that day; null for an Invalid Date or a year before 0000.
 */
export function roundedCalendarDateOfInstant(instant) {
    const rounded = new Date(instant.getTime() + HALF_DAY_MS);
    if (Number.isNaN(rounded.getTime()))
        return null;
    const year = rounded.getUTCFullYear();
    if (year > 9999)
        return LAST_CALENDAR_DATE;
    return year < 0 ? null : calendarDateOfUtcInstant(rounded);
}
/** The instants that {@link roundedCalendarDateOfInstant} reads as `day`: half-open, as a Prisma range. */
export function instantsRoundingToDay(day) {
    const midnight = toPrismaDate(day).getTime();
    return { gte: new Date(midnight - HALF_DAY_MS), lt: new Date(midnight + HALF_DAY_MS) };
}
/** {@link roundedCalendarDateOfInstant} for a GraphQL string; a bare `YYYY-MM-DD` is taken as is. */
export function roundedCalendarDateOfIso(iso) {
    if (isCalendarDate(iso))
        return iso;
    const instant = parseInstantOrNull(iso);
    return instant ? roundedCalendarDateOfInstant(instant) : null;
}
//# sourceMappingURL=format-from-iso.js.map